import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';

app.initializers.add('ralkage-word-counter', () => {
    // Capture the initial value (e.g. when editing an existing post) and
    // trigger redraws on every keystroke so the count stays current.
    extend(TextEditor.prototype, 'buildEditorParams', function (params) {
        if (params.value && !this.wordCountValue) {
            this.wordCountValue = params.value;
        }

        const original = params.oninput;
        params.oninput = (value) => {
            if (original) original(value);
            this.wordCountValue = value;
            m.redraw();
        };
    });

    extend(TextEditor.prototype, 'controlItems', function (items) {
        const text = this.wordCountValue || '';
        const trimmed = text.trim();

        const words = trimmed.length === 0 ? 0 : trimmed.split(/\s+/).length;
        const chars = text.length;

        items.add(
            'wordCounter',
            <span className="WordCounter">
                {app.translator.trans('ralkage-word-counter.forum.composer.word_counter', { words, chars })}
            </span>,
            -100
        );
    });
});
